export default (initialValue = false) => ({
    state: false,
    trigger() {
        this.state = true;
        this.$dispatch('update', this.state);
    },
    init() {
        this.state = initialValue;
    }
});